const route = [
    {//课前预习选章节
        path: '/english/before/taskset',
        component: function (resolve) {
            require(['VIEWS/english/english/before/taskset'], resolve);
        }
    },
    {//课前预习选作业
        path: '/english/before/listset/:id',
        component: function (resolve) {
            require(['VIEWS/english/english/before/listset'], resolve);
        }
    },
    {//课前预习预览
        //type:0单词预览 1课文预览 2预览发布
        path: '/english/before/preview/:type',
        component: function (resolve) {
            require(['VIEWS/english/english/before/preview'], resolve);
        }
    },
    {//同步习题选章节
        path: '/english/test/taskset/:sid',
        component: function (resolve) {
            require(['VIEWS/english/english/test/taskset'], resolve);
        }
    },
    {//同步习题选作业
        path: '/english/test/screen/:sid',
        component: function (resolve) {
            require(['VIEWS/english/english/test/screen'], resolve);
        }
    },
    {//同步习题自己选题
        path: '/english/test/taskselect/:sid',
        component: function (resolve) {
            require(['VIEWS/english/english/test/taskselect'], resolve);
        }
    },
    {//同步习题预览
        //type:0试题预览 1课文预览 2预览发布
        path: '/english/test/preview/:type/:sid',
        component: function (resolve) {
            require(['VIEWS/english/english/test/preview'], resolve);
        }
    },
    {//同步习题预览
        //type:0试题预览 1课文预览 2预览发布
        path: '/english/wrong/index/:sid',
        component: function (resolve) {
            require(['VIEWS/english/english/wrong/index'], resolve);
        }
    },
];
export default route
